/**
 * @ignore
 * These are common keywords used across rd3g, thus being placed in a more abstract level
 * in the tree directory.
 */
const graphConst = {
  SYMBOLS: {
    CIRCLE: "circle",
    CROSS: "cross",
    DIAMOND: "diamond",
    SQUARE: "square",
    STAR: "star",
    TRIANGLE: "triangle",
    WYE: "wye",
  },
};

export default graphConst;